import AdminUploading from './AdminUploading'

export default AdminUploading
